module.exports = __webpack_public_path__ + "img/expression-cool.a07fcec4.png";